import { render, staticRenderFns } from "./Carriers.vue?vue&type=template&id=1755cf1e"
import script from "./Carriers.vue?vue&type=script&lang=js"
export * from "./Carriers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports